<template>
  <div class="room-content--wrapper" @click="gotoResa">
    <div class="room-item">
      <div class="picture--content">
        <img :src="picture" alt=""/>
      </div>
      <div class="text--content">
        <div class="top-line">
          <div class="room-name">{{ title }}</div>
          <div class="room-price">{{ price | decimalPrice }} €</div>
        </div>
        <div class="room-desc" v-if="sameDate" v-html="$t('step2.page.date', `<span>${dateStart}</span>`)"></div>
        <div class="room-desc" v-else
             v-html="$t('step2.page.dates', `<span>${dateStart}</span>`, `<span>${dateEnd}</span>`)"></div>
      </div>
    </div>
    <div class="room-extras" v-if="extras.length > 0">
      <cart-extra v-for="(_item, index) in extras" :item="_item" :index="index" :key="_item.id"/>
    </div>
    <a href="javascript:void(0)" class="delete-booking" @click="handleDelete">{{ $t('step4.rooms.delete') }}</a>
  </div>
</template>

<script>
import moment from 'moment'
import CartExtra from "./cart-extra";

export default {
  components: {CartExtra},
  props: ['item'],
  computed: {
    picture() {
      return this.item ? `${this.item.room.main_picture.absolute_path}?w=100&h=100&crop-to-fit` : '-'
    },
    title() {
      return this.item ? this.item.room.text.short_name : '-'
    },
    dateStart() {
      return this.item ? moment(this.$props.item.start, 'YYYY-MM-DD HH:mm:ss').format('D MMMM YYYY') : '-'
    },
    dateEnd() {
      return this.item ? moment(this.item.end, 'YYYY-MM-DD HH:mm:ss').format('D MMMM YYYY') : '-'
    },
    sameDate() {
      if (!this.item) return false;
      return moment(this.$props.item.start, 'YYYY-MM-DD HH:mm:ss').format('D MMMM YYYY') === moment(this.item.end, 'YYYY-MM-DD HH:mm:ss').format('D MMMM YYYY');
    },
    price() {
      const pricePlanId = this.item.room_price_id;
      let price = 0
      for (const pricePlan of this.item.price_plans) {
        for (const edge of pricePlan.input_prices[0].edges) {
          if (edge.from.id === pricePlanId) {
            price += edge.totalPrice
          }
        }
      }
      return price;
    },
    extras() {
      return this.item.extras;
    }
  },
  methods: {
    async gotoResa() {
      await this.$router.push({
        name: 'step3', params: {
          shoppingCart: this.$store.state.shoppingCart.uuid,
          shoppingBookingId: this.item.id
        }
      })
    },
    async handleDelete(e) {
      e.preventDefault();
      e.stopPropagation();
      await this.$store.dispatch('shoppingCart/booking/bookingRoom/delete', {id: this.item.id});
    }
  },
  name: "cart-room"
}
</script>

<style scoped>
.picture--content img {
  width: 50px;
  height: 50px;
}

.room-content--wrapper a.delete-booking::before, .room-content--wrapper a.delete-booking::after {
  display: none !important;
  content: '';
}

.room-content--wrapper a.delete-booking {
  background: none;
  position: absolute;
  transition: all 300ms ease;
  bottom: -26px;
  top: auto;
  width: 100%;
  left: 0;
  right: 0;
  text-align: center;
  color: var(--white);
  opacity: 0;
  transform: translateX(50px);
  text-decoration: none;
  font-style: italic;
}

.room-wrapper:hover a.delete-booking {
  opacity: 1;
  transform: translateX(0);
}

.room-item {
  position: relative;
  display: grid;
  grid-template-columns: 50px 1fr;
}

.room-item img {
  border-radius: 6px;
}

.room-content--wrapper {
  position: relative;
  cursor: pointer;
}

.room-extras::before {
  content: '';
  position: absolute;
  width: 5px;
  background: #37373d;
  top: calc(50px + .4rem);
  bottom: 0;
  border-radius: 2.5px;
}

.room-item .text--content {
  margin-left: 1rem;
}

.room-item .text--content .top-line {
  display: flex;
  margin-bottom: .4rem;
}

.room-item .text--content .top-line .room-name {
  flex: 0 0 auto;
  margin: 0 auto auto 0;
  color: var(--white);
}

.room-item .text--content .top-line .room-price {
  flex: 0 0 auto;
  margin: 0 0 auto auto;
  color: var(--darker-orange);
}

.room-item .text--content .room-desc {
  color: #a2acb2;
  font-size: .8em;
}

.room-wrapper:hover .room-item .text--content .room-desc {
  color: #d6e4eb;
}

.room-wrapper:hover .room-item .text--content .top-line .room-price {
  color: var(--white);
}
</style>



// WEBPACK FOOTER //
// src/components/topbar/cart-room.vue